import React from 'react';
import { ConfigProvider } from 'antd';
import RootRouter from "../src/router/rootRouter";
import './App.css';
import Header from 'components/Header';

// Ant Design v5 theme configuration (migrated from LESS variables in config-overrides.js)
const antdTheme = {
  token: {
    colorPrimary: '#6528d8',
    colorLink: '#6528d8',
    borderRadius: 6,
  },
};

function App() {
  return (
    <ConfigProvider theme={antdTheme}>
      <div className="App">
        <Header />
        <RootRouter />
      </div>
    </ConfigProvider>
  );
}

export default App;
